import React from 'react';
import { Redirect } from 'react-router-dom';
import Index from '../pages/Assessment';
import Content from '../pages/Content/index';
import RecaptchaComponent from '../pages/Qrcode/RecaptchaComponent';
import CompletedPage from '../pages/CompletedPage';
import Dashboard from '../pages/Dashboard';
import PageNotFound from '../pages/Errors/PageNotFound';
import DIndex from '../pages/DashboardLogin';
import AssessmentFinished from '../pages/AssessmentFinised';

// Higher-order component to include Navbar with the main content component
const NavbarComponentWithRoute = (Component) => (props) =>
    (
        <>
            <Component {...props} />
        </>
    );

export const allRoutesOfApplication = [
    { path: '/marriott-anthem', exec: true, component: RecaptchaComponent },
    { path: '/anthem', exec: true, component: RecaptchaComponent },
    { path: '/umoja', exec: true, component: RecaptchaComponent },
    { path: '/marriott*', component: PageNotFound },
    { path: '/dashboard', component: Dashboard },
    { path: '/:uniqueLinkId/:memberId', component: NavbarComponentWithRoute(Index) },
    { path: '/assessmentCompleted', component: NavbarComponentWithRoute(CompletedPage) },
    { path: '/login', component: DIndex },
    { path: '/assessment', component: NavbarComponentWithRoute(AssessmentFinished) },
    { path: '/', exact: true, component: Content },
    { path: '*', component: PageNotFound }
];
